import styled from 'styled-components';

import { body } from '@constants/fonts';

export const ChartStyle = styled.div<{ width: string }>`
  box-sizing: border-box;
  padding: 40px 0 40px 20px;
  border-radius: 10px;
  max-width: 652px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: ${(props) => props.width};
  font-family: ${body};

  ${(props) => props.theme.breakpoints.down('sm')} {
    padding: 0;
  }
`;

export const TopBar = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 90%;
`;

export const ChartOptionsWrapper = styled.div`
  flex-wrap: wrap;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 60%;
  ${(props) => props.theme.breakpoints.down('sm')} {
    justify-content: space-evenly;
    flex-wrap: nowrap;
    width: 100%;
  }
`;
